import { watch } from "vue";
import { cookieStore } from "@/shared/utils/store/use-store";
import { StringHelper } from "@/helpers/string-helper";
import { useUserData } from "@/account/use-user-data";
import { useBreakpoints } from "@/shared/utils/responsive/use-breakpoints";
import { storeToRefs } from "pinia";

function initVideoService() {
    const isSm = useBreakpoints("sm");

    const homepageWheelStartAnimPlayed = cookieStore.get("homepageWheelStartAnimPlayed");

    const videoStartElem = document.getElementById("homepage-wheel-anim-start") as HTMLVideoElement;
    const videoLoopElem = document.getElementById("homepage-wheel-anim-loop") as HTMLVideoElement;

    const showLoopVideo = () => {
        videoLoopElem.style["display"] = "block";

        videoLoopElem.load();
        videoLoopElem.play();
    };

    const showStartVideo = () => {
        videoStartElem.style["display"] = "block";

        videoStartElem.load();
        videoStartElem.play();
    };

    const onStartVideoFinished = () => {
        videoStartElem.removeEventListener("ended", onStartVideoFinished);
        videoStartElem.style["display"] = "none";

        // reload video sources when resize
        watch(isSm, () => showLoopVideo(), { immediate: true });

        cookieStore.set("homepageWheelStartAnimPlayed", "1");
    };

    if (homepageWheelStartAnimPlayed == "1") {
        // reload video sources when resize
        watch(isSm, () => showLoopVideo(), { immediate: true });
    } else {
        videoStartElem.addEventListener("ended", onStartVideoFinished, false);
        showStartVideo();
    }
}

function initBannerSpinsCount() {
    const bannerSpinsCountElement = document.getElementById("kasa-homepage-header-spins-count");

    if (!bannerSpinsCountElement) return;

    const { userData } = storeToRefs(useUserData());

    watch(
        () => userData.value.availableSpins,
        () => {
            bannerSpinsCountElement.innerHTML = StringHelper.getChanceInflection(userData.value.availableSpins);
        },
        {
            immediate: true,
        }
    );
}

document.ready(() => {
    initVideoService();
    initBannerSpinsCount();
});
